/** Configuración pública (VITE_*). Nunca contiene secretos. */
export interface AppConfig {
  supabaseUrl: string;
  publishableKey: string;
  functionsUrl: string;
  mode: 'cloud' | 'demo';
}

export function readConfig(): { config: AppConfig | null; problems: string[] } {
  const url = import.meta.env.VITE_SUPABASE_URL?.trim() ?? '';
  const key = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY?.trim() ?? '';
  const mode = import.meta.env.VITE_APP_MODE === 'demo' ? 'demo' : 'cloud';
  const problems: string[] = [];
  if (mode === 'cloud') {
    if (!/^https?:\/\//.test(url)) problems.push('VITE_SUPABASE_URL no está definida.');
    if (!key) problems.push('VITE_SUPABASE_PUBLISHABLE_KEY no está definida.');
    if (/service_role|sb_secret_/.test(key)) problems.push('La clave configurada parece administrativa: nunca debe ir en el cliente.');
  }
  if (problems.length) return { config: null, problems };
  return {
    config: { supabaseUrl: url.replace(/\/$/, ''), publishableKey: key, functionsUrl: `${url.replace(/\/$/, '')}/functions/v1`, mode },
    problems,
  };
}

export const APP_VERSION = '0.1.0';
